/**
 * WireTopic — a content topic used for ABAC gating, article tagging, and feed configuration.
 * The slug is the stable identifier flowing through LDAP/IdAM, JACOs, and article tags.
 * The label is display-only.
 *
 * Data lives in /public/config/topics.json so it can be swapped at deploy time
 * without a frontend rebuild. Use `fetchTopics()` or `useTopics()` to load it.
 *
 * ⚠️  The JSON file contains DEV PLACEHOLDER values. Real slugs are replaced
 *     on the production network without modifying this code.
 */
export type WireTopic = {
  slug: string
  label: string
}

export async function fetchTopics(): Promise<WireTopic[]> {
  const res = await fetch('/config/topics.json')
  if (!res.ok) throw new Error(`Failed to load topics config: ${res.status}`)
  return res.json() as Promise<WireTopic[]>
}
